import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'Budget',
  mixins: [validationMixin],
  components: {

  },
  props: ['dataObj'],
  data: function () {
    return {
      budget: {
        index: 0,
        budgetId: '',
        employeeId: 0,
        employee: '',
        description: '',
        invoiceNo: '',
        purchaseOrderNo: '',
        requisitionNo: '',
        amount: 0,
        readOnly: false,
      },
      employee: {
        displayString: '',
        employeeId: 0,
        employeeName: '',
        orgPost: 0,
        orgPostName: '',
        rateHours: { 1: 0, 2: 50, 3: 0, 4: 0, 5: 0 },
        station: 0,
        stationName: '',
        teamId: -1
      },
      budgets: [],
      employees: []
    }
  },
  validations: {
    budget: {
      required
    },
  },
  computed: {
    selectionCount: function () {
      return this.selection.length;
    },
  },
  watch: {
    employee: function (value) {
      if (!value)
        return;
      this.dataObj.employeeId = value.employeeId;
      this.dataObj.employee = value.displayString;
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.budget = this.dataObj;
        this.budgets = this.dataObj.budgets;
        this.employees = this.dataObj.employees;
        if (this.employees.filter(p => p.employeeId === this.dataObj.employeeId) && this.employees.filter(p => p.employeeId === this.dataObj.employeeId).length > 0)
          this.employee = this.employees.filter(p => p.employeeId === this.dataObj.employeeId)[0];
      });
    },
    setSelectedBudget(value) {
      console.log(value);
    },
  },
}

